module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_pet-ca6571f29f1206d2c19d897bc19855b2.webp";